import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Lock, Mail } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const sessionMessage = location.state && location.state.message;

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await axios.post(`${BACKEND_URL}/api/admin/login`, { email, password });
      localStorage.setItem('admin_token', res.data.token);
      localStorage.setItem('admin_email', res.data.email);
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="admin-login-page">
      <div className="w-full max-w-md p-8 bg-white rounded-2xl shadow-xl border border-slate-100">
        <div className="text-center mb-8">
          <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-[#0096D6]/10 flex items-center justify-center">
            <Lock className="w-7 h-7 text-[#0096D6]" />
          </div>
          <h1 className="font-outfit text-2xl font-bold text-slate-900">Admin Portal</h1>
          <p className="font-manrope text-sm text-slate-500 mt-1">Real Tech Services Ltd</p>
        </div>

        {sessionMessage && (
          <div className="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-xl text-amber-700 text-sm font-manrope text-center">
            {sessionMessage}
          </div>
        )}

        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="font-manrope text-sm font-medium text-slate-700 block mb-1">Email</label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full pl-10 pr-4 py-3 rounded-xl border border-slate-200 font-manrope text-sm focus:border-[#0096D6] focus:ring-1 focus:ring-[#0096D6]/20"
                placeholder="admin@realtechservices.co.uk"
                required
                data-testid="admin-email-input"
              />
            </div>
          </div>
          <div>
            <label className="font-manrope text-sm font-medium text-slate-700 block mb-1">Password</label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full pl-10 pr-4 py-3 rounded-xl border border-slate-200 font-manrope text-sm focus:border-[#0096D6] focus:ring-1 focus:ring-[#0096D6]/20"
                placeholder="Enter password"
                required
                data-testid="admin-password-input"
              />
            </div>
          </div>

          {error && (
            <p className="text-red-500 text-sm font-manrope text-center" data-testid="admin-login-error">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded-xl bg-[#0096D6] text-white font-manrope font-semibold text-sm hover:bg-[#007bb0] transition-colors disabled:opacity-50"
            data-testid="admin-login-button"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
